export const SEARCH_ALERT_JOB_PREFERENCES_LABEL_ID =
  'search-alert-job-preferences-banner-toggler';
